import { FC } from 'react';
import { Center, Image } from '@chakra-ui/react';

import notepad from 'assets/brand/notepad@2x.png';
import Text from 'components/_core/Text';

import locales from './locales';

interface DirectDebitEmptyViewProps {
  isRevoked: boolean;
}

const DirectDebitEmptyView: FC<DirectDebitEmptyViewProps> = ({ isRevoked }) => (
  <Center flexDirection="column" paddingY="space-32" textAlign="center">
    {!isRevoked ? (
      <>
        <Image
          alt=""
          height="96px"
          marginBottom="space-24"
          role="presentation"
          src={notepad}
          width="144px"
        />

        <Text
          fontWeight="weight-500"
          marginBottom="space-8"
          size="lg"
          variant="primary"
        >
          {locales.titleActive}
        </Text>

        <Text>{locales.descriptionActive}</Text>
      </>
    ) : (
      <Text>{locales.descriptionSuspended}</Text>
    )}
  </Center>
);

export default DirectDebitEmptyView;
